var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col justify-center items-center h-full"},[_c('p',{staticClass:"text-xl font-medium text-center watermark mb-3"},[_vm._v("Uploading...")]),_c('i8-progress',{attrs:{"value":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }